import React from "react";
import CommentCard from "../CommentCard/CommentCard";
import styles from "./CommentList.module.css";

const CommentList = (props) => {
  const titleStatus = {
    approved: "Completion Rejection reason",
    "review required": "Rejection reason",
    cancelled: "Cancellation reason",
  };

  const getTitle = (item) => {
    return item.status === "comment"
      ? `${item.createdBy}'s comment`
      : `${item.createdBy} - ${titleStatus[item.status]}`;
  };

  const excludedItems = ["created objective", "created development goal"];

  const getItemAudit = (auditList) => {
    if (
      excludedItems.includes(auditList.toLowerCase()) ||
      auditList.includes("Updated") ||
      auditList.includes("Manually")
    ) {
      return auditList;
    }
    const spacedAuditList = auditList.replace(/,/g, ", ");
    const changedObjList = spacedAuditList.split(":");
    const changedObjArray = changedObjList[1] && changedObjList[1].split(",");

    return (
      <div style={{ marginTop: "6px" }}>
        <p>{changedObjList[0]}:</p>
        <ul>
          {changedObjArray.map((changedObj) => (
            <li key={changedObj}>{changedObj}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className={styles.CommentList}>
      {props.data.length ? (
        <>
          {props.type !== "audit" && <span>Previous comments</span>}
          {props.data.reverse().map((item, index) => (
            <CommentCard
              key={index}
              type={props.type}
              date={item.createdAt}
              submittedBy={props.type === "audit" ? item.user : getTitle(item)}
              message={props.type === "audit" ? getItemAudit(item.text) : item.comment}
              link={props.type === "audit" ? item.link : null}
            />
          ))}
        </>
      ) : (
        <span>No previous {props.type === "audit" ? "actions" : "comments"}</span>
      )}
    </div>
  );
};

export default CommentList;
